import { render } from "./BidsTable.vue?vue&type=template&id=3093962a&scoped=true&lang=pug"
import script from "./BidsTable.vue?vue&type=script&lang=ts"
export * from "./BidsTable.vue?vue&type=script&lang=ts"

import "./BidsTable.vue?vue&type=style&index=0&id=3093962a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3093962a"

export default script